import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";

import { ProductUpdatePcm } from "api/memberPortal/product/productUpdate/productUpdate.types";
import {
  useCreateProductUpdatePcmMutation,
  useGetProductUpdatePcmQuery,
  useUpdateProductUpdatePcmMutation,
} from "api/memberPortal/product/productUpdate/productUpdatePcm.api";

import ProductUpdateBaseModal from "./ProductUpdateBase.modal";

interface ProductUpdateModalProps {
  editMode?: boolean;
}

const PcmUpdateModal = ({ editMode }: ProductUpdateModalProps) => {
  const { id: parentId, updateId } = useParams();
  const pathParams = updateId && parentId ? { parentId, updateId } : undefined;

  const { data: currentUpdate } = useGetProductUpdatePcmQuery(
    pathParams ?? skipToken,
    {
      skip: !editMode,
    },
  );

  const [triggerCreate] = useCreateProductUpdatePcmMutation();
  const [triggerEdit] = useUpdateProductUpdatePcmMutation();

  return (
    <ProductUpdateBaseModal<ProductUpdatePcm>
      editMode={editMode ?? false}
      onEdit={triggerEdit}
      onCreate={triggerCreate}
      currentUpdate={currentUpdate}
    />
  );
};
export default PcmUpdateModal;
